import Box from '@mui/material/Box';
import React, {ReactNode} from 'react';
import {sx} from './sx'
import {SetStatePropsType} from "@baseTypes/base";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import DoubleArrowLeftIconSecondary from "@resource/svg/DoubleArrowLeftIconSecondary";
import {classNames} from "@helpers/classNames";
import Paper from '@mui/material/Paper';
import {IRootSidebarSxSingleVoyage} from "@containers/singleVoyage/views/layout/rootSidebar/types";

interface IProps {
    children: ReactNode,
    miniMode: boolean,
    setMiniMode: SetStatePropsType<boolean>,
    sx?: IRootSidebarSxSingleVoyage,
    headerChildren?: ReactNode
}

const RootSidebarLayoutSingleVoyage = ({
                               children,
                               miniMode,
                               setMiniMode,
                               sx: sxProps = {},
                               headerChildren,
                           }: IProps) => {

    const toggleMode = () => {
        setMiniMode((prev) => !prev)
    }
    return (
        <Paper
            sx={{
                ...sx.root,
                ...(sxProps?.root ?? {}),
            }}
            className={classNames(miniMode && 'miniMode')}
        >
            <Box
                sx={{
                    ...sx.header,
                    ...(sxProps?.header ?? {}),
                }}
                className={classNames(miniMode && 'miniMode', 'rootSidebarHeader')}
            >
                <IconButtonCustom
                    onClick={toggleMode}
                    color={'#fff'}
                >
                    <DoubleArrowLeftIconSecondary sx={sx.toggleIcon}/>
                </IconButtonCustom>

                {headerChildren && headerChildren}
            </Box>

            <Box
                sx={{
                    ...sx.inner,
                    ...(sxProps?.inner ?? {}),
                }}
                className={classNames('blue-scrollbar', miniMode && 'miniMode')}
            >
                {children}
            </Box>
        </Paper>
    );
};

export default RootSidebarLayoutSingleVoyage;